import {useRef} from 'react';
import type {GridItemStorage} from '@Components/base-grid/components/grid-item';
import {getTilesNotYetShown} from '@Panels/stock-panel/stock-panel.library';
import type {ShownTiles} from '@Panels/stock-panel/stock-panel.types';

/** Remembers which tile ids a grid has shown, so that a later batch drops the tiles it repeats. */
export const useShownTiles = (): ShownTiles => {
  const shownIds = useRef<Set<string>>(new Set());

  const dropTilesAlreadyShown = (tiles: GridItemStorage[]): GridItemStorage[] => {
    const newTiles = getTilesNotYetShown(tiles, shownIds.current);
    newTiles.forEach((tile) => shownIds.current.add(tile.id));
    return newTiles;
  };

  const forgetShownTiles = (): void => {
    shownIds.current = new Set();
  };

  return {dropTilesAlreadyShown, forgetShownTiles};
};
